import { H3 } from '@packages/ui'
import { forwardRef } from 'react'
import { Stack, StackProps } from '@mantine/core'
import { cn } from '@packages/ui/utils'

export const PageContentPaper = forwardRef<HTMLDivElement, StackProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Stack
        ref={ref}
        className={cn(
          'ui-content-paper text-surface-foreground rounded-lg p-2 sm:p-4 2xl:p-8',
          className
        )}
        {...props}
      >
        {props.title && <H3 className={'m-0 p-0'}>{props.title}</H3>}
        {children}
      </Stack>
    )
  }
)

PageContentPaper.displayName = 'PageContentPaper'
